export const getLineNewsSelector = ({ news }) => news.lineData

export const getListNewsSelector = ({ news }) => news.listData
